module.exports = __webpack_public_path__ + "static/img/mt.65399e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mt.png
// module id = ZIqm
// module chunks = 0